import { SelectOption } from '@/components/form-builder/form-builder.types';
import { DacDocSubmission, DacDocSubmissionDto } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface DacDocSubmissionStateProps {
  response?: DacDocSubmission;
  dto: DacDocSubmissionDto;
  initialDto?: DacDocSubmissionDto;
  folderTypeSelected?: SelectOption;
  docSubmissionNotInDacSelected?: SelectOption;
  isEqual: boolean;
  serverState: any;
  errors: Record<string, any>;
}

export const dacDocSubmissionInitialState: DacDocSubmissionStateProps = {
  dto: {
    dacId: undefined,
    docSoumissionId: undefined,
    dateValidate: new Date(),
  },
  folderTypeSelected: { name: '', code: undefined },
  docSubmissionNotInDacSelected: {
    name: '',
    code: undefined,
  },
  isEqual: true,
  serverState: undefined,
  errors: {},
};

export const dacDocSubmissionStateStore = createStore(
  { name: 'dac-doc-submission-state' },
  withProps<DacDocSubmissionStateProps>({
    ...dacDocSubmissionInitialState,
  })
);

export const dacDocSubmissionStoreFactory = (id: string) => {
  return createStore(
    { name: `dac-doc-submission--state-${id}` },
    withProps<DacDocSubmissionStateProps>(structuredClone(dacDocSubmissionInitialState))
  );
};
